import React from "react";
import { Toaster } from "sonner";
import { IUser } from "@interfaces";
import { es } from "primelocale/es.json";
import { Datejs } from "@nubeteck/utils";
import { addLocale } from "primereact/api";
import queryClient from "@lib/query-client";
import { NavigationProvider } from "@contexts";
import { IconsProvider } from "@nubeteck/icons";
import { Outlet, Navigate } from "react-router";
import { HeaderActionsProvider } from "@nubeteck/prime";
import { createStore, AuthProvider } from "@nubeteck/auth";
import { QueryClientProvider } from "@tanstack/react-query";

import { routes } from "./navigation";

addLocale("es", es);
Datejs.locale("es");

const store = createStore<IUser>({
  authName: "_auth",
  authType: "cookie",
  cookieDomain: window.location.hostname,
  cookieSecure: window.location.protocol === "https:",
});

const AppProviders = () => {
  return (
    <AuthProvider
      store={store}
      fallbackPath="/login"
      OutletComponent={Outlet}
      permissionKey="permisos"
      NavigateComponent={Navigate}
    >
      <QueryClientProvider client={queryClient}>
        <HeaderActionsProvider>
          <NavigationProvider routes={routes} />
        </HeaderActionsProvider>
        <Toaster richColors />
        <IconsProvider />
      </QueryClientProvider>
    </AuthProvider>
  );
};

export default AppProviders;
